import { render, staticRenderFns } from "./OrderDetailTable.vue?vue&type=template&id=31ff1b10&scoped=true&"
import script from "./OrderDetailTable.vue?vue&type=script&lang=js&"
export * from "./OrderDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff1b10",
  null
  
)

export default component.exports